<mat-toolbar class="p-0 mat-elevation-z1" *ngIf="translations">

    <mat-progress-bar *ngIf="showLoadingBar" class="loading-bar" color="accent" mode="indeterminate"></mat-progress-bar>

    <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">

        <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">

            <button mat-button class="toggle-button-navbar mat-icon-button"
                    fuseNavbarVertical="toggleBar" fxHide.gt-md>
                <mat-icon>menu</mat-icon>
            </button>

            <div class="toolbar-separator" fxHide.gt-md></div>
            <h2 style="max-width: calc(100vw - 120px);
            overflow: hidden;"> &nbsp;&nbsp;{{translations.lblApplicationHeader}} </h2>

        </div>

        <div id="rightMenu" *ngIf="userInfo" class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">
            <button mat-button [matMenuTriggerFor]="userMenu" class="user-button">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <img class="avatar" src="assets/images/avatars/profile.jpg">
                    <span class="username mr-24" fxHide fxShow.gt-sm>
                        {{ translations.lblGreet +' '+ userInfo.UserName }}
                        <!-- <label style="font-size: x-small;">({{translations.lastLoginLabel}} : {{ userInfo.LastLoginDate | date : 'medium' }})</label>  -->
                    </span>
                    <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
                </div>
            </button>
            <mat-menu #userMenu="matMenu" xPosition="before" style="margin-top:64px !important">

                <button mat-menu-item  (click)="changePwdDialog()" style="max-width: 100% !important;" >
                    <mat-icon>settings</mat-icon>
                    <span>{{translations.lblChangePassword}}</span>
                </button>


                <button mat-menu-item class="" (click)="logout();" style="max-width: 100% !important;" >
                    <mat-icon>exit_to_app</mat-icon>
                    <span>{{translations.lblLogout}}</span>
                </button>

            </mat-menu>


        </div>
    </div>
</mat-toolbar>



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/toolbar/toolbar.component.html